module.exports = __webpack_public_path__ + "img/onboarding.bf19bfe9.svg";